import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingSkipConstructionFactor, selectBalancingSkipProductionFactor, } from "../../balancingSelectors/selectBalancingConstants";
import { selectBuildingConstructionInProgress } from "../../selectors/selectBuildingConstructionInProgress";
import { selectOngoingPurchaseProcessToSkip } from "../../selectors/selectOngoingPurchaseInfo";
import { getRecipeIcon } from "../generic/icon/getRecipeIcon";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionQuickSkipConstructionSkip, actionQuickSkipProductionSkip } from "./actionQuickSkip";
import { IdQuickSkip } from "./IdQuickSkip";
import { QuickSkipConstruction } from "./QuickSkipConstruction";
import { QuickSkipProduction } from "./QuickSkipProduction";
var _DialogQuickSkip = function (_a) {
    var processToQuickSkip = _a.processToQuickSkip, buildingSelected = _a.buildingSelected, onClose = _a.onClose, onSkipProduction = _a.onSkipProduction, buildingInConstruction = _a.buildingInConstruction, onSkipConstruction = _a.onSkipConstruction, productionProcessTotalTime = _a.productionProcessTotalTime, constructionProcessTotalTime = _a.constructionProcessTotalTime, productionIcon = _a.productionIcon;
    if (buildingSelected == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var skipProductionFactor = selectBalancingSkipProductionFactor();
    var skipConstructionFactor = selectBalancingSkipConstructionFactor();
    if (processToQuickSkip === IdQuickSkip.Production) {
        return (React.createElement(QuickSkipProduction, { building: buildingSelected, onCancel: onClose, processTotalTime: productionProcessTotalTime, onSkip: onSkipProduction, skipProcessFactor: skipProductionFactor, icon: productionIcon }));
    }
    return (React.createElement(QuickSkipConstruction, { skipProcessFactor: skipConstructionFactor, onSkip: onSkipConstruction, processTotalTime: constructionProcessTotalTime, onCancel: onClose, building: buildingSelected, buildingInConstruction: buildingInConstruction }));
};
var mapState = function (state) {
    var buildingSelected = state.playerBase.buildings.building;
    var constructionProcessTotalTime = 0;
    var productionProcessTotalTime = 0;
    var productionIcon = IdIcon.TimeIcn;
    if (buildingSelected) {
        var proto = buildingSelected.proto, balancing = buildingSelected.balancing, production = buildingSelected.production;
        var stage = proto.stage ? proto.stage - 1 : 0;
        constructionProcessTotalTime = balancing.stage[stage].constructionTime;
        if (production &&
            production.production &&
            production.production.amount &&
            production.recipe &&
            production.recipe.productionTime) {
            var recipeAmount = production.production.amount;
            productionProcessTotalTime = production.recipe.productionTime * (recipeAmount || 1);
            productionIcon = getRecipeIcon(production.recipe);
        }
    }
    return {
        buildingInConstruction: selectBuildingConstructionInProgress(state),
        buildingSelected: buildingSelected,
        constructionProcessTotalTime: constructionProcessTotalTime,
        processToQuickSkip: selectOngoingPurchaseProcessToSkip(state),
        productionIcon: productionIcon,
        productionProcessTotalTime: productionProcessTotalTime,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.SkipProcess)); },
    onSkipConstruction: function (building, action) {
        return dispatch(actionQuickSkipConstructionSkip(building, action));
    },
    onSkipProduction: function (building) {
        return dispatch(actionQuickSkipProductionSkip(building));
    },
}); };
export var DialogQuickSkip = connect(mapState, mapDispatch)(_DialogQuickSkip);



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-skip-dialog/DialogQuickSkip.tsx
// module id = 2891
// module chunks = 3